module.exports = __webpack_public_path__ + "img/logo-dark2x.ea55090a.svg";